// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Styles */
body {
  font-family: Verdana, sans-serif;
  color: #6c757d;
  background-color: #ffffff;
  color: #333;
  text-align: center;
  line-height: 120%;
}

h1, h2, h3, h4, h5, h6 {
  font-family: Verdana, sans-serif;
}

a {
  color: black;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.italics {
  font-style: italic;
  color: #999;
  font-size: 14px;
}

@media (max-width: 768px) {  
  .hide-mobile {
    display: none!important;
  }
}

/* Header */
.header {
  align-items: center;
  width: 100%;
  justify-content: space-between;
  position: fixed;
  z-index: 3;
  background: white;
}

.header > * {
  display: flex;
  gap: 40px;
  align-items: center;
}

.header-top {
  padding: 1rem;
  border-bottom: 1px solid #ccc;
}

.header-top h1 {
  text-transform: uppercase;
  font-weight: 800;
  letter-spacing: -2px;
}

.logo-container {
  width: 80px;
  height: 80px;
}

.logo {
  width: 100%;
  height: auto;
}

h1 {
  font-size: 24px;
}

.main-nav {
  display: block;
  font-size: 14px;
  font-weight: 800;
  border-bottom: 1px solid #ccc;
}

.main-nav ul {
  list-style: none;
  display: flex;
  gap: 0.5rem;
  padding-left: 0;
  width: auto;
  align-items: center;
}

.main-nav ul li {
  margin-right: 1rem;
  flex: 1 1;
}

.header-top-logo {
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;
}

.header-link {
  margin-left: auto;
  text-align: left;
  display: flex;
  gap: 24px;
  font-size: 14px;
}

.header-link > * {
  flex: 1 1;
}

.header-link svg {
  margin-top: 4px;
}

.header-link-child {
  display: flex;
  gap: 8px;
}

@media (max-width: 768px) {  
  .main-nav ul {
    padding-left: 8px;
    padding-right: 8px;
  }

  .header-top {
    display: block;
    padding-bottom: 16px;
  }

  .header-link {
    margin-top: 12px;
    /* flex-direction: column; */
    gap: 12px;
  }

  h1 {
    font-size: 20px;
  }
}

/* App */
.App {
  padding-top: 145px;
}

@media (max-width: 768px) {  
  .App {
    padding-top: 150px;
  }
}

/* Introduction Banner */
.introduction-banner {
  text-align: center;
  padding: 2rem 0;
  height: 40vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  position: relative;
}

.intro-text {
  position: relative;
  z-index: 2;
}

.banner-image {
  max-width: 100%;
  height: auto;
}

/* Flyers */
#flyers {
  padding: 40px 16px 16px;
}

.flyers-container {
  display: flex;
  flex-direction: row;
  border-radius: 9px;
  max-width: 1000px;
  margin: 0 auto;
  background: #efefef;
  align-items: center;
}

.flyers-container > * {
  flex: 1 1;
}

.flyer-image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.flyer-text-container {
  text-align: left;
  padding: 24px;
  line-height: 140%;
}

@media (max-width: 768px) {
  .flyers-container {
    flex-direction: column; 
  }
}

/* Services List */
#services {
  position: relative;
  /* top: -160px; */
  padding: 16px;
}

.services-list {
  display: flex;
  flex-wrap: wrap;
  justify-content:center;
  gap: 16px;
  padding: 1rem 0 4rem;
}

.service {
  text-align: center;
  background: #efefef;
  border-radius: 9px;
  flex: 1 1 28.9%;
  flex-grow: 0;
  padding: 16px;
}

.service svg {
  width: 80px;
}

.gallery-list {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.gallery-list > *{
  flex: 1 1 40%;
}

.gallery-list img {
  width: 100%;
}

@media (max-width: 768px) {
  #services {
    padding: 16px;
  }

  .service {
    flex: 1 1 100%;
  }

  .gallery-list > * {
    flex: 1 1 100%;
  }
}

/* Pricing */
#pricing {
  position: relative;
  padding: 16px;
}

.pricing {
  text-align: center;
  padding: 2rem 0;
}

.pricing .service {
  flex: 1 1;
  background: rgb(233, 252, 227);
}

@media (max-width: 768px) {
  #pricing {
    padding: 16px;
  }

  .pricing .service {
    flex: 1 1 100%;
  }
}

/* Location */
#location {
  position: relative;
  padding: 16px;
}

.location {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
}

.location-container {
  width: 100%;
  padding: 40px;
  text-align: left;
}

.google-map {
  width: 100%;
  height: 50vh;
  flex: 0 0 60%;
  border-radius: 9px;
}

.map-address-link {
  margin-top: 1rem;
  text-decoration: underline;
}

.location-address {
  text-decoration: none;
  margin-bottom: 32px;
}

.location h4 {
  margin: 0 0 8px;
}

.location-address svg {
  margin-right: 0.5rem;
}

@media (max-width: 768px) {
  #location {
    padding: 16px
  }

  .location {
    display: block;
  }

  .location-container {
    padding: 24px 0 0 0;
    text-align: center;
  }
}

/* Footer */
.footer {
  background: #333;
  color: white;
  text-align: center;
  padding: 1rem 16px 3rem;
}

.social-links {
  margin-top: 1rem;
  display: inline-block;
  padding: 16px 32px;
}

.social-link {
  color: white;
  display: inline-block;
  height: 50px;
  width: auto;
}

.social-link img {
  height: 100%;
}

.footer-copyright-container {
  padding-top: 3rem;
  margin-top: 1rem;
  border-top: 1px solid #555;
}

/* Responsive Design */
@media (max-width: 768px) {  
  .service {
      width: 100%;
  }

  .google-map {
      max-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,gCAAgC;EAChC,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,4BAA4B;IAC5B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,QAAQ;AACR;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,WAAW;AACX;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,8BAA8B;AAChC;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE;EACF;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;MACI,WAAW;EACf;;EAEA;MACI,eAAe;EACnB;AACF","sourcesContent":["/* General Styles */\nbody {\n  font-family: Verdana, sans-serif;\n  color: #6c757d;\n  background-color: #ffffff;\n  color: #333;\n  text-align: center;\n  line-height: 120%;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: Verdana, sans-serif;\n}\n\na {\n  color: black;\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\n.italics {\n  font-style: italic;\n  color: #999;\n  font-size: 14px;\n}\n\n@media (max-width: 768px) {  \n  .hide-mobile {\n    display: none!important;\n  }\n}\n\n/* Header */\n.header {\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n  position: fixed;\n  z-index: 3;\n  background: white;\n}\n\n.header > * {\n  display: flex;\n  gap: 40px;\n  align-items: center;\n}\n\n.header-top {\n  padding: 1rem;\n  border-bottom: 1px solid #ccc;\n}\n\n.header-top h1 {\n  text-transform: uppercase;\n  font-weight: 800;\n  letter-spacing: -2px;\n}\n\n.logo-container {\n  width: 80px;\n  height: 80px;\n}\n\n.logo {\n  width: 100%;\n  height: auto;\n}\n\nh1 {\n  font-size: 24px;\n}\n\n.main-nav {\n  display: block;\n  font-size: 14px;\n  font-weight: 800;\n  border-bottom: 1px solid #ccc;\n}\n\n.main-nav ul {\n  list-style: none;\n  display: flex;\n  gap: 0.5rem;\n  padding-left: 0;\n  width: auto;\n  align-items: center;\n}\n\n.main-nav ul li {\n  margin-right: 1rem;\n  flex: 1;\n}\n\n.header-top-logo {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  align-items: center;\n}\n\n.header-link {\n  margin-left: auto;\n  text-align: left;\n  display: flex;\n  gap: 24px;\n  font-size: 14px;\n}\n\n.header-link > * {\n  flex: 1;\n}\n\n.header-link svg {\n  margin-top: 4px;\n}\n\n.header-link-child {\n  display: flex;\n  gap: 8px;\n}\n\n@media (max-width: 768px) {  \n  .main-nav ul {\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n\n  .header-top {\n    display: block;\n    padding-bottom: 16px;\n  }\n\n  .header-link {\n    margin-top: 12px;\n    /* flex-direction: column; */\n    gap: 12px;\n  }\n\n  h1 {\n    font-size: 20px;\n  }\n}\n\n/* App */\n.App {\n  padding-top: 145px;\n}\n\n@media (max-width: 768px) {  \n  .App {\n    padding-top: 150px;\n  }\n}\n\n/* Introduction Banner */\n.introduction-banner {\n  text-align: center;\n  padding: 2rem 0;\n  height: 40vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  position: relative;\n}\n\n.intro-text {\n  position: relative;\n  z-index: 2;\n}\n\n.banner-image {\n  max-width: 100%;\n  height: auto;\n}\n\n/* Flyers */\n#flyers {\n  padding: 40px 16px 16px;\n}\n\n.flyers-container {\n  display: flex;\n  flex-direction: row;\n  border-radius: 9px;\n  max-width: 1000px;\n  margin: 0 auto;\n  background: #efefef;\n  align-items: center;\n}\n\n.flyers-container > * {\n  flex: 1;\n}\n\n.flyer-image-container img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.flyer-text-container {\n  text-align: left;\n  padding: 24px;\n  line-height: 140%;\n}\n\n@media (max-width: 768px) {\n  .flyers-container {\n    flex-direction: column; \n  }\n}\n\n/* Services List */\n#services {\n  position: relative;\n  /* top: -160px; */\n  padding: 16px;\n}\n\n.services-list {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content:center;\n  gap: 16px;\n  padding: 1rem 0 4rem;\n}\n\n.service {\n  text-align: center;\n  background: #efefef;\n  border-radius: 9px;\n  flex: 1 1 28.9%;\n  flex-grow: 0;\n  padding: 16px;\n}\n\n.service svg {\n  width: 80px;\n}\n\n.gallery-list {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.gallery-list > *{\n  flex: 1 1 40%;\n}\n\n.gallery-list img {\n  width: 100%;\n}\n\n@media (max-width: 768px) {\n  #services {\n    padding: 16px;\n  }\n\n  .service {\n    flex: 1 1 100%;\n  }\n\n  .gallery-list > * {\n    flex: 1 1 100%;\n  }\n}\n\n/* Pricing */\n#pricing {\n  position: relative;\n  padding: 16px;\n}\n\n.pricing {\n  text-align: center;\n  padding: 2rem 0;\n}\n\n.pricing .service {\n  flex: 1;\n  background: rgb(233, 252, 227);\n}\n\n@media (max-width: 768px) {\n  #pricing {\n    padding: 16px;\n  }\n\n  .pricing .service {\n    flex: 1 1 100%;\n  }\n}\n\n/* Location */\n#location {\n  position: relative;\n  padding: 16px;\n}\n\n.location {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 16px;\n}\n\n.location-container {\n  width: 100%;\n  padding: 40px;\n  text-align: left;\n}\n\n.google-map {\n  width: 100%;\n  height: 50vh;\n  flex: 0 0 60%;\n  border-radius: 9px;\n}\n\n.map-address-link {\n  margin-top: 1rem;\n  text-decoration: underline;\n}\n\n.location-address {\n  text-decoration: none;\n  margin-bottom: 32px;\n}\n\n.location h4 {\n  margin: 0 0 8px;\n}\n\n.location-address svg {\n  margin-right: 0.5rem;\n}\n\n@media (max-width: 768px) {\n  #location {\n    padding: 16px\n  }\n\n  .location {\n    display: block;\n  }\n\n  .location-container {\n    padding: 24px 0 0 0;\n    text-align: center;\n  }\n}\n\n/* Footer */\n.footer {\n  background: #333;\n  color: white;\n  text-align: center;\n  padding: 1rem 16px 3rem;\n}\n\n.social-links {\n  margin-top: 1rem;\n  display: inline-block;\n  padding: 16px 32px;\n}\n\n.social-link {\n  color: white;\n  display: inline-block;\n  height: 50px;\n  width: auto;\n}\n\n.social-link img {\n  height: 100%;\n}\n\n.footer-copyright-container {\n  padding-top: 3rem;\n  margin-top: 1rem;\n  border-top: 1px solid #555;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {  \n  .service {\n      width: 100%;\n  }\n\n  .google-map {\n      max-width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
